import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { ArrowRight } from "@phosphor-icons/react";

export default function ResetPassword() {
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirm) {
      toast.error("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", {
        email,
        token: token.trim(),
        new_password: newPassword,
      });
      toast.success("Password updated — sign in with your new password");
      navigate("/login");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not reset password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-[1440px] mx-auto grid lg:grid-cols-2 border-b border-[var(--border)] min-h-[calc(100vh-4rem)]">
      <div className="hidden lg:block bg-black relative grain">
        <div className="absolute inset-0 flex items-end p-12 text-white">
          <div>
            <div className="micro-label text-white/60">/ Livery workshop</div>
            <h2 className="font-display font-black text-5xl mt-2 leading-[0.95]">
              Reset your<br />
              <span className="text-[var(--accent)]">password.</span>
            </h2>
          </div>
        </div>
      </div>
      <div className="p-8 md:p-16 flex items-center">
        <form onSubmit={onSubmit} className="w-full max-w-sm mx-auto" data-testid="reset-password-form">
          <div className="micro-label">/ Reset password</div>
          <h1 className="font-display font-black text-4xl mt-1">Enter your code</h1>
          <p className="text-[var(--fg-2)] text-sm mt-3">
            Locked out?{" "}
            <Link to="/contact" className="text-[var(--accent)] underline">
              Email support
            </Link>{" "}
            for a reset code, then use it below.
          </p>

          <label className="block mt-8">
            <span className="micro-label">Email</span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full h-11 px-3 border border-[var(--border)] bg-white font-mono text-sm focus:border-black focus:outline-none"
              data-testid="input-reset-email"
            />
          </label>
          <label className="block mt-4">
            <span className="micro-label">Reset code</span>
            <input
              type="text"
              required
              value={token}
              onChange={(e) => setToken(e.target.value)}
              placeholder="Paste the code support sent you"
              className="mt-2 w-full h-11 px-3 border border-[var(--border)] bg-white font-mono text-sm focus:border-black focus:outline-none"
              data-testid="input-reset-token"
            />
          </label>
          <label className="block mt-4">
            <span className="micro-label">New password</span>
            <input
              type="password"
              required
              minLength={8}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="mt-2 w-full h-11 px-3 border border-[var(--border)] bg-white font-mono text-sm focus:border-black focus:outline-none"
              data-testid="input-new-password"
            />
          </label>
          <label className="block mt-4">
            <span className="micro-label">Confirm new password</span>
            <input
              type="password"
              required
              minLength={8}
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="mt-2 w-full h-11 px-3 border border-[var(--border)] bg-white font-mono text-sm focus:border-black focus:outline-none"
              data-testid="input-confirm-password"
            />
          </label>

          <button
            type="submit"
            disabled={loading}
            className="btn-accent w-full mt-8 inline-flex items-center justify-center gap-2"
            data-testid="btn-reset-submit"
          >
            {loading ? "Updating…" : (<>Reset password <ArrowRight size={14} weight="bold" /></>)}
          </button>
        </form>
      </div>
    </div>
  );
}
